export const FORM_CONTROLLER_NAME_PREFIX = 'eastcoal'
